<template>
    <form @submit="submit_form">
        <!-- Title -->
        <div class="mb-3">
            <h2 class="h5 mb-0">Informations personnelles</h2>
        </div>
        <!-- End Title -->

        <div class="row">
            <!-- Input -->
            <div class="col-sm-6 mb-6">
                <div class="js-form-message">
                    <label id="nameLabel" class="form-label">
                        Nom d'affichage
                        <span class="text-danger"></span>
                    </label>

                    <div class="form-group">
                        <input v-model="user.profile.displayName" type="text" class="form-control" name="name"
                               placeholder="Entrer nom et prénom(s)..." aria-label="Entrer nom et prénom(s)..."
                               aria-describedby="nameLabel"
                               data-msg="Veuillez entrer nom et prénom(s)...."
                               data-error-class="u-has-error"
                               data-success-class="u-has-success">
                        <small class="form-text text-muted">Affiché sur votre profil et sur vos posts.</small>
                    </div>
                </div>
            </div>
            <!-- End Input -->

            <!-- Input -->
            <div class="col-sm-6 mb-6">
                <div class="js-form-message">
                    <label id="usernameLabel" class="form-label">
                        Nom d'utilisateur
                    </label>

                    <div class="form-group">
                        <input v-model="user.username" type="text" class="form-control" name="username"
                               placeholder="Entrer votre nom d'utilisateur" aria-label="Entrer votre nom d'utilisateur"
                               aria-describedby="usernameLabel"
                               data-msg="Veuillez entrer votre nom d'utilisateur."
                               data-error-class="u-has-error"
                               data-success-class="u-has-success">
                    </div>
                </div>
            </div>
            <!-- End Input -->
        </div>

        <label class="form-label">
            Date d'anniversaire
        </label>

        <!-- Birthday & Gender -->
        <div class="row">
            <!-- Month Input -->
            <div class="col-md-6 mb-3 mb-sm-6">
                <div class="js-form-message">
                    <div class="form-group">
                        <select ref="birthMonth" class="form-control custom-select"
                                data-msg="Sélectionner un mois."
                                data-error-class="u-has-error"
                                data-success-class="u-has-success">
                            <option value="">Mois</option>
                            <option v-for="(month, idx) in months" :key="idx" :value="idx+1"
                                    :selected="idx===birthday.month-1">
                                {{month}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <!-- End Month Input -->

            <!-- Date Input -->
            <div class="col-sm-4 col-md-2 mb-3 mb-sm-6">
                <div class="js-form-message">
                    <div class="form-group">
                        <select ref="birthDay" class="form-control custom-select"
                                data-msg="Please select date."
                                data-error-class="u-has-error"
                                data-success-class="u-has-success">
                            <option value="">Jour</option>
                            <option v-for="date in 31" :key="date" :value="date" :selected="date===birthday.day">
                                {{ date }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <!-- End Date Input -->

            <!-- Year Input -->
            <div class="col-sm-4 col-md-2 mb-3 mb-sm-6">
                <div class="js-form-message">
                    <div class="form-group">
                        <select ref="birthYear" class="form-control custom-select"
                                data-msg="Please select year."
                                data-error-class="u-has-error"
                                data-success-class="u-has-success">
                            <option value="">Année</option>
                            <option v-for="(year, idx) in years" :key="idx" :value="year"
                                    :selected="year===birthday.year">
                                {{ year }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <!-- End Year Input -->

            <!-- Gender Input -->
            <div class="col-sm-4 col-md-2 mb-6">
                <div class="js-form-message">
                    <div class="form-group">
                        <select v-model="user.profile.sex" class="form-control custom-select"
                                data-msg="Please select your gender."
                                data-error-class="u-has-error"
                                data-success-class="u-has-success">
                            <option v-for="(sex, index) in sexes" :key="index" :value="sex.value"
                                    :selected="sex.value===user.profile.sex">
                                {{ sex.value }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <!-- End Gender Input -->
        </div>
        <!-- End Birthday & Gender -->

        <div class="row">
            <!-- Input -->
            <div class="col-sm-6 mb-6">
                <div class="js-form-message">
                    <label id="emailLabel" class="form-label">
                        Adresse email
                    </label>

                    <div class="form-group">
                        <input v-model="user.email" type="email" class="form-control" name="email" value="natalie.curtis@gmail.com"
                               placeholder="Entrer votre adresse e-mail" aria-label="Enter your email address"
                               readonly aria-describedby="emailLabel"
                               data-msg="Please enter a valid email address."
                               data-error-class="u-has-error"
                               data-success-class="u-has-success">
                        <small class="form-text text-muted">Nous ne dévoilerons votre mail à personne d'autre que
                            vous.</small>
                    </div>
                </div>
            </div>
            <!-- End Input -->

            <!-- Input -->
            <div class="col-sm-6 mb-6">
                <div class="js-form-message">
                    <label id="locationLabel" class="form-label">
                        Location
                    </label>

                    <div class="form-group">
                        <input v-model="user.profile.location" type="text" class="form-control" name="location"
                               placeholder="Entrer votre location" aria-label="Enter your location"
                               aria-describedby="locationLabel"
                               data-msg="Please enter your location."
                               data-error-class="u-has-error"
                               data-success-class="u-has-success">
                    </div>
                </div>
            </div>
            <!-- End Input -->
        </div>

        <div class="row">
            <!-- Input -->
            <div class="col-sm-6 mb-6">
                <div class="js-form-message">
                    <label id="organizationLabel" class="form-label">
                        Lieu de travail
                    </label>

                    <div class="form-group">
                        <input v-model="user.profile.workplace" type="text" class="form-control" name="organization"
                               placeholder="Entrer le nom de votre lieu de travail..."
                               aria-label="Entrer le nom de votre lieu de travail..."
                               aria-describedby="organizationLabel"
                               data-msg="Please enter your organization name"
                               data-error-class="u-has-error"
                               data-success-class="u-has-success">
                    </div>
                </div>
            </div>
            <!-- End Input -->

            <!-- Input -->
            <div class="col-sm-6 mb-6">
                <div class="js-form-message">
                    <label id="websiteLabel" class="form-label">
                        Lien site web
                    </label>

                    <div class="form-group">
                        <input v-model="user.profile.websiteUrl" class="form-control" type="url" name="website"
                               placeholder="Entrer le lien vers votre site web"
                               aria-label="Entrer le lien vers votre site web" aria-describedby="websiteLabel"
                               data-msg="Password enter a valid website"
                               data-error-class="u-has-error"
                               data-success-class="u-has-success">
                        <small class="form-text text-muted">Lien de votre site de présentation, votre blog ou votre
                            lieu de travail, e.g. http://example.com</small>
                    </div>
                </div>
            </div>
            <!-- End Input -->
        </div>

        <div class="row">
            <!-- Input -->
            <div class="col-sm-6 mb-6">
                <div class="js-form-message">
                    <label id="phoneNumberLabel" class="form-label">
                        Numéro de téléphone
                    </label>

                    <div class="form-group">
                        <input v-model="user.profile.phoneNumber" class="form-control" type="tel" name="phoneNumber"
                               placeholder="Entrer votre numéro de téléphone"
                               aria-label="Entrer votre numéro de téléphone" aria-describedby="phoneNumberLabel"
                               data-msg="Please enter a valid phone number"
                               data-error-class="u-has-error"
                               data-success-class="u-has-success">
                    </div>
                </div>
            </div>
            <!-- End Input -->

            <div class="col-sm-6 mb-6">
                <label id="profession" class="form-label">Profession</label>

                <!-- Input -->
                <div class="input-group">
                    <input v-model="user.profile.profession" type="text" class="form-control"
                           placeholder="Enter votre profession" aria-label="Enter votre profession"
                           aria-describedby="profession">
                </div>
                <!-- End Input -->
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 mb-6">
                <label id="biography" class="form-label">Biographie</label>

                <!-- Input -->
                <div class="input-group">
                    <textarea v-model="user.profile.biography" class="form-control"
                              placeholder="Parlez nous de vous en quelques phrases"
                              aria-label="Parlez nous de vous en quelques phrases" aria-describedby="biography"/>
                </div>
                <!-- End Input -->
            </div>
        </div>

        <!-- Title -->
        <div class="mb-5">
            <p>Ajouter des liens vers vos réseaux sociaux.</p>
        </div>
        <!-- End Title -->

        <!-- Twitter link input -->
        <div class="mb-6">
            <div class="js-focus-state form-group">
                <div class="input-group">
                    <div id="twitterProfileLabel" class="input-group-prepend">
                        <span class="input-group-text">{{ twitterBaseUrl }}</span>
                    </div>
                    <input v-model="twitterUsername" type="text" class="form-control" placeholder="Profil twitter"
                           aria-label="Twitter profile"
                           aria-describedby="twitterProfileLabel"
                           data-msg="Please enter a valid URL address."
                           data-error-class="u-has-error"
                           data-success-class="u-has-success">
                </div>
                <small class="form-text text-muted">Entrer votre nom d'utilisateur Twitter (e.g. yannick_kiki)</small>
            </div>
        </div>
        <!-- End Twitter link input -->

        <!-- Facebook link input -->
        <div class="mb-6">
            <div class="js-focus-state form-group">
                <div class="input-group">
                    <div id="facebookProfileLabel" class="input-group-prepend">
                        <span class="input-group-text"> {{ facebookBaseUrl }} </span>
                    </div>
                    <input v-model="facebookUsername" type="text" class="form-control" placeholder="Profil Facebook"
                           aria-label="Facebook profile"
                           aria-describedby="facebookProfileLabel"
                           data-msg="Please enter a valid URL address."
                           data-error-class="u-has-error"
                           data-success-class="u-has-success">
                </div>
                <small class="form-text text-muted">Entrer votre nom d'utilisateur Facebook (e.g. yannick_kiki)</small>
            </div>
        </div>
        <!-- End Facebook link input -->

        <!-- Submit Errors -->
        <div class="mb-6">
            <p v-if="error" class="text-danger">{{ error }}</p>
        </div>
        <!-- End Submit Errors -->

        <LoadingButton v-if="requestIsLoading"/>
        <button v-else type="submit" class="btn btn-sm btn-primary transition-3d-hover mr-1">Enregistrer</button>
    </form>
</template>

<script>
    import {UserManager} from "../managers";
    import {FACEBOOK_BASE_URL, MONTHS, TWITTER_BASE_URL} from "../settings";
    import {deepCopy, range, zeroPad} from "../xlib";
    import {SEX} from "../settings/enums";
    import {UPDATE_PERSONAL_INFO} from "../settings/graphql";
    import {mapMutations} from "vuex";
    import LoadingButton from "./LoadingButton";
    import {errorMessageDisplay} from "../xlib/graphql";

    export default {
        name: "PersonalInfoForm",
        components: {LoadingButton},
        data() {
            return {
                user: deepCopy(this.$store.state.user.info),
                twitterBaseUrl: TWITTER_BASE_URL,
                twitterUsername: UserManager.getTwitterUsername(this.$store.state.user.info),
                facebookBaseUrl: FACEBOOK_BASE_URL,
                facebookUsername: UserManager.getFacebookUsername(this.$store.state.user.info),
                birthday: UserManager.getBirthday(this.$store.state.user.info),
                months: MONTHS,
                years: range(2020, 1900, -1),
                sexes: SEX,
                requestIsLoading: false,
                error: ""
            }
        },
        methods: {
            ...mapMutations([
                'setUserInfo'
            ]),
            storeUserInfo(info) {
                this.setUserInfo(info);
            },
            submit_form: function (event) {
                event.preventDefault();
                this.$data.requestIsLoading = true;

                let user = this.$data.user;

                user.profile.twitterLink = this.$data.twitterUsername ? this.$data.twitterBaseUrl + this.$data.twitterUsername : null;
                user.profile.facebookLink = this.$data.facebookUsername ? this.$data.facebookBaseUrl + this.$data.facebookUsername : null;

                const birthYear = this.$refs.birthYear.value;
                const birthMonth = this.$refs.birthMonth.value;
                const birthDay = this.$refs.birthDay.value;
                user.profile.birthday = `${birthYear}-${zeroPad(birthMonth, 2)}-${zeroPad(birthDay, 2)}`;
                // console.log(`User birthday: ${user.profile.birthday}`);

                // console.log(`Updating user: ${JSON.stringify(user)}`);

                this.$apollo.mutate({
                    mutation: UPDATE_PERSONAL_INFO,
                    variables: {
                        displayName: user.profile.displayName, username: user.username, birthday: user.profile.birthday,
                        sex: user.profile.sex, location: user.profile.location, workplace: user.profile.workplace,
                        websiteUrl: user.profile.websiteUrl, phoneNumber: user.profile.phoneNumber,
                        profession: user.profile.profession, biography: user.profile.biography,
                        twitterLink: user.profile.twitterLink, facebookLink: user.profile.facebookLink
                    }
                }).then((result) => {
                    // console.log(result.data);
                    this.storeUserInfo(result.data.updatedUser.user);
                    this.$data.requestIsLoading = false;
                    this.$router.push({
                        'name': 'viewProfile', 'params': {'username': this.$store.state.user.info.username}
                    })
                }).catch((error) => {
                    // console.error(`We encountered error ${JSON.stringify(error)} on user personal info updating...`);
                    this.$data.error = errorMessageDisplay(error);
                    this.$data.requestIsLoading = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>